import {inject, Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {AuthorityService} from "@auth/services/authority.service";
import * as AuthorityActions from "./authority.actions";
import { catchError, exhaustMap, of } from 'rxjs';
import { map } from 'rxjs/operators';
import {AuthorityDto} from "@shared/dto";

@Injectable()
export class AuthorityEffects {
  private readonly actions$ = inject(Actions);
  private readonly authorityService = inject(AuthorityService);

  readAuthorities$ = createEffect(() => this.actions$.pipe(
    ofType(AuthorityActions.readAuthorities),
    exhaustMap(() => this.authorityService.read().pipe(
      map((data: AuthorityDto[]) => AuthorityActions.readAuthoritiesSuccess({ data })),
      catchError((error) => of(AuthorityActions.readAuthoritiesFailure({ error })))
    ))
  ));

}
